import { themeUtils } from '@/lib/utils'
import { i18n }       from '@/lang/lang'

// eslint-disable-next-line no-unused-vars
// const PlaceHolder = () => themeUtils.importThemeComponent('components/common/PlaceHolder')
const Home = () => themeUtils.importThemeComponent('views/home/Home')
const About = () => themeUtils.importThemeComponent('views/about/About')
const Press = () => themeUtils.importThemeComponent('views/press/Press')
const PressArticle = () => themeUtils.importThemeComponent('views/press/PressArticle')
const ContactForm = () => themeUtils.importThemeComponent('views/contact/ContactForm')
const CaseStudies = () => themeUtils.importThemeComponent('views/case-studies/CaseStudies')

export const AppRoutes = {
  SimpleRoutes: [
    {
      name    : 'Default',
      path    : '*',
      redirect: '/' + i18n.locale
    }
  ],

  LangRoutes: [
    {
      name     : 'Home',
      path     : '',
      component: Home,
      props    : true,
      meta     : {
        layout: 'default'
      }
    },
    {
      name     : 'AboutUs',
      path     : 'about-us',
      component: About,
      props    : true,
      meta     : {
        layout: 'default'
      }
    },
    {
      name     : 'CaseStudies',
      path     : 'case-studies',
      component: CaseStudies,
      props    : true,
      meta     : {
        layout: 'default'
      }
    },
    {
      name     : 'Press',
      path     : 'press',
      component: Press,
      props    : true,
      meta     : {
        layout: 'default'
      }
    },
    {
      name     : 'PressArticle',
      path     : 'press/article/:slug?',
      component: PressArticle,
      props    : true,
      meta     : {
        layout: 'default'
      }
    },
        {
      name     : 'ContactUs',
      path     : 'contact-us',
      component: ContactForm,
      props    : true,
      meta     : {
        layout: 'default'
      }
    }
  ]
}

export default AppRoutes
